<template>
  <div class="view contentBody">
    <div class="title">工作交接</div>
    <div class="connect_group">
      <div class="connect_item_box">
        <p class="connect_item_title">选择交出方</p>
        <div class="connect_item_body">
          <p v-if="!hand_name">
            <span class="connect_item_choose" @click="chooseemployee('H')">选择交出人</span>
          </p>
          <div v-else>
            <p class="connect_check_name mb-20">{{hand_name}}</p>
            <p class="connect_check_line">客户人数 <em>{{hand_number}}</em> 人</p>
            <p class="connect_item_choose_agin" @click="chooseemployee('H')">重新选择</p>
          </div>
        </div>
      </div>
      <div class="iconfont iconyuanquyunwei- handoverIcon"></div>
      <div class="connect_item_box">
        <p class="connect_item_title">选择接收方</p>
        <div class="connect_item_body">
          <p v-if="!receive_name">
            <span class="connect_item_choose" @click="chooseemployee('R')">选择接收人</span>
          </p>
          <div v-else>
            <p class="connect_check_name mb-20">{{receive_name}}</p>
            <p class="connect_check_line">包含 <em>{{receive_number}}</em> 名客户</p>
            <p class="connect_item_choose_agin" @click="chooseemployee('R')">重新选择</p>
          </div>
        </div>
      </div>
    </div>
    <p class="last_connect_check_user" v-if="customerDiff">目标交接客户数 <em>{{customerDiff.customer}}</em> 人，重合客户数 <em>{{customerDiff.repeat}}</em> 人，实际交接客户数 <em>{{customerDiff.diff}}</em> 人</p>
    <p class="mt20 set_wrap_line">
      <el-button type="primary" @click="handover" size="small">开始交接</el-button>
    </p>
    <chooseEmployeeDialog
            :dialogtitle="dialogtitle"
            :type="type"
            :visible.sync="chooseemployeedialog"
            v-if="chooseemployeedialog"
            @checkedemployee="checkedemployee"
    ></chooseEmployeeDialog>

    <el-dialog
      title="存在重合客户数，请选择要被覆盖的一方"
      :visible.sync="showDialog"
      :append-to-body="true"
      width="30%"
      custom-class="whd-dialog-noborder"
      >
 
        <el-radio v-model="radio" label="2">交出方</el-radio>
        <el-radio v-model="radio" label="1">接收方</el-radio>
   
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>    
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseEmployeeDialog from "@/components/dialog/chooseEmployeeDialog.vue";

  export default {
    name: "handover",
    components: {
      chooseEmployeeDialog
    },
    data() {
      return {
        type: "",
        itype: "",      // 1覆盖被交接方的数据(右边的)，2覆盖交接方的数据(左边的)
        radio: 1,
        hand_id: "",
        hand_name: "",
        hand_number: 0,
        receive_id: "",
        receive_name: "",
        receive_number:0,
        dialogtitle: "",
        chooseemployeedialog: false,
        customerDiff:null,
        showDialog: false
      };
    },
    methods: {
      // 锁客
      chooseemployee(type) {
        this.dialogtitle = type == "H" ? "选择交出方" : "选择接收方";
        this.type = type;
        this.chooseemployeedialog = true;
      },
      checkedemployee(val, type) {
        if (type === "H") {
          if (this.receive_id === val.id) {
            this.$message({
              message: "他已在接收方，不能重复",
              type: "warning"
            });
            return
          }
          this.hand_id = val.id;
          this.hand_name = val.name;
          this.responFn(1,val.id) // 获取员工客户数 1
        }
        if (type === "R") {
          if (this.hand_id === val.id) {
            this.$message({
              message: "他已在交出方，不能重复",
              type: "warning"
            });
            return
          }
          this.receive_id = val.id;
          this.receive_name = val.name;
          this.responFn(3,val.id) // 获取员工客户数 1
        }
        if (this.hand_id && this.receive_id) {
          // 进行比对信息
          this.responFn(2)
        }
      },
      responFn(option,id) {
        //handover_customer 获取员工客户数; handover_customer_diff 获取客户重合信息
        // option 1 获取员工客户数; 2 获取客户重合信息
        let url_ = api.handover_customer
        let data_ = {employee_id: id}
        if (option === 2) {
          url_ = api.handover_customer_diff
          data_ = {hand_id: this.hand_id, receive_id: this.receive_id} // hand_id 交出方id receive_id 接收方id
        }
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                if (option === 1) {
                  this.hand_number = response.data.number
                }else if(option === 3){
                  this.receive_number = response.data.number
                }else{
                  // "customer":"目标交接客户数", "repeat":"重合客户数", "diff":"实际交接客户数"
                  this.customerDiff = response.data.info
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 交接
      handover() {
        if (this.hand_id === "" || this.receive_id === "") {
          this.$message({
            message: "请选择交出方或者接收方",
            type: "warning"
          });
          return false;
        }
        if (this.hand_id === this.receive_id) {
          this.$message({
            message: "交出方和接收方不能相同",
            type: "warning"
          });
          return false;
        }
        if (this.customerDiff && this.customerDiff.repeat > 0) {
          this.showDialog = true;
          this.onConfirm();
        } else {
          this.apiHandover();
        }
      },
      onConfirm() {
        this.itype = this.radio;
        this.showDialog = false;
        this.apiHandover();
      },
      apiHandover() {
        let params = {
          hand_id: this.hand_id,
          receive_id: this.receive_id,
          type: this.itype
        };
        this.axios
            .post(api.handover_index, params)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: "交接成功",
                  type: "success"
                });
                this.$router.go(0);
              } else {
                this.$message({
                  message: "交接失败",
                  type: "success"
                });
              }
            })
            .catch(response => {
              this.$message({
                message: "交接失败",
                type: "success"
              });
            });
      }
    }
  };
</script>
